enum WorkspaceOrganizationStatus {
  Active = 'Active',
  Archived = 'Archived',
}

export default WorkspaceOrganizationStatus
